import { render, staticRenderFns } from "./loginuser0001.vue?vue&type=template&id=490c4e7b&"
import script from "./loginuser0001.vue?vue&type=script&lang=js&"
export * from "./loginuser0001.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports